/**
 * Product Grid V2 Components
 * Entry point for all Product Grid V2 web components
 */

import ProductCardV2Slider from "./product-card-slider";
import ProductGridV2BreakerSlider from "./breaker-slider";

// Register web components
if (!window.customElements.get("product-card-v2-slider")) {
  window.customElements.define("product-card-v2-slider", ProductCardV2Slider);
}

if (!window.customElements.get("product-grid-v2-breaker-slider")) {
  window.customElements.define("product-grid-v2-breaker-slider", ProductGridV2BreakerSlider);
}

export { ProductCardV2Slider, ProductGridV2BreakerSlider };
